import React from "react";
import { useSelector } from "react-redux";
import Flicking from "@egjs/react-flicking";
import _ from "lodash";

import readingTime from "../illustrations/undraw_reading_time_gvg1.svg";
import ReadingListCard from "./ReadingListCard";

import { makeStyles, createStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      minWidth: 275,
    },
    bullet: {
      display: "inline-block",
      margin: "0 2px",
      transform: "scale(0.8)",
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
    paper: {
      marginTop: 18,
      marginBottom: 18,
      paddingBottom: 12,
      paddingRight: 12,
      paddingLeft: 12,
      background: theme.palette.primary.light,
      backgroundImage: `url(${readingTime})`,
      backgroundPosition: "left",
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      backgroundOrigin: "content-box",
    },
    readingListTitle: {
      paddingTop: 12,
      color: "white",
      background: theme.palette.primary.light,
    },
    readingListSubtitle: {
      color: "white",
      background: theme.palette.primary.light,
    },
  })
);

export default function ReadingListSlider() {
  const classes = useStyles();
  const readingList = useSelector((state) => state.readingList);

  const renderCard = () => {
    return _.toArray(readingList).map((item) => {
      return (
        <ReadingListCard
          key={item.id}
          id={item.id}
          title={item.title}
          rating={item.rating}
          cover={item.cover}
        />
      );
    });
  };

  return (
    <>
      <Paper elevation={3} className={classes.paper}>
        <Typography
          variant="h5"
          className={classes.readingListTitle}
          //align="right"
        >
          Reading List
        </Typography>

        <Typography
          variant="subtitle1"
          gutterBottom
          className={classes.readingListSubtitle}
          //align="right"
        >
          Sit back, relax, and enjoy some good reads
        </Typography>

        <Flicking
          horizontal={true}
          circular={false}
          infinite={false}
          defaultIndex={0}
          inputType={["touch", "mouse"]}
          thresholdAngle={45}
          bounce={10}
          autoResize={true}
          adaptive={true}
          bound={false}
          overflow={false}
          hanger={"50%"}
          anchor={"50%"}
          gap={10}
          moveType={{ type: "snap", count: 1 }}
          collectStatistics={false}
          zIndex={100}
        >
          {renderCard()}
        </Flicking>
      </Paper>
    </>
  );
}
